// PublicRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './usersContext';  
// Or wherever you manage "currentUser"

function PublicRoute({ children }) {
  const { currentUser } = useUser();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  if (currentUser) {
    // Already logged in => redirect to the last visited page
    return <Navigate to={from} replace />;
  }

  // If NOT logged in => render the wrapped component (e.g. Register form)
  return children;
}

export default PublicRoute;
